// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"823f410d","132":"0354e5a1","143":"0354e5a1","380":"823f410d","467":"c7584c48","688":"a0938b0e","740":"0354e5a1"}[chunkId] + ".chunk.css";
};